import { kebabCase } from 'lodash';

const urlPrefix = '/virtual/showroom';

const CATALOG = () => ({ url: `${urlPrefix}/catalog`, title: 'Showroom Vehicle Catalog' });
const VDP_USED = (modelYear) => ({
    url: `${urlPrefix}/vdp/used/${kebabCase(modelYear)}`,
    title: `Showroom VDP - Used - ${modelYear}`,
});
const VDP_NEW = (modelYear) => ({
    url: `${urlPrefix}/vdp/new/${kebabCase(modelYear)}`,
    title: `Showroom VDP - New - ${modelYear}`,
});
const LISTING_USED = () => ({
    url: `${urlPrefix}/listing/used`,
    title: `Showroom Inventory Listing - Used`,
});
const LISTING_NEW = () => ({
    url: `${urlPrefix}/listing/new`,
    title: `Showroom Inventory Listing - New`,
});
const BUILD_AND_QUOTE_YEAR = (model) => ({
    url: `${urlPrefix}/build-and-quote/year/${kebabCase(model)}`,
    title: `Showroom Build and Quote - Model Year Selection Step - ${model}`,
});
const BUILD_AND_QUOTE_TRIM = (modelYear) => ({
    url: `${urlPrefix}/build-and-quote/trim/${kebabCase(modelYear)}`,
    title: `Showroom Build and Quote - Trim Selection Step - ${modelYear}`,
});
const BUILD_AND_QUOTE_PERFORMANCE = (modelYear) => ({
    url: `${urlPrefix}/build-and-quote/performance/${kebabCase(modelYear)}`,
    title: `Showroom Build and Quote - Performance Options Selection Step - ${modelYear}`,
});
const BUILD_AND_QUOTE_COMFORT = (modelYear) => ({
    url: `${urlPrefix}/build-and-quote/comfort/${kebabCase(modelYear)}`,
    title: `Showroom Build and Quote - Comfort Options Selection Step - ${modelYear}`,
});
const BUILD_AND_QUOTE_ACCESSORIES = (modelYear) => ({
    url: `${urlPrefix}/build-and-quote/accessories/${kebabCase(modelYear)}`,
    title: `Showroom Build and Quote - Options and Accessories Selection Step - ${modelYear}`,
});
const ESTIMATED_TRADEIN_VEHICLE = () => ({
    url: `${urlPrefix}/tradein/estimated/vehicle`,
    title: `Showroom Trade-in - Estimated - Vehicle Information and Mileage Form`,
});
const ESTIMATED_TRADEIN_CONDITION = () => ({
    url: `${urlPrefix}/tradein/estimated/condition`,
    title: `Showroom Trade-in - Estimated - Adjust Value For Vehicle Condition`,
});
const OFFICIAL_TRADEIN = () => ({
    url: `${urlPrefix}/tradein/official`,
    title: `Showroom Trade-in - Official`,
});
const OFFICIAL_TRADEIN_VEHICLE_FORM = () => ({
    url: `${urlPrefix}/tradein/official/vehicle-form`,
    title: `Showroom Trade-in - Official - Vehicle Form Step`,
});
const OFFICIAL_TRADEIN_CAR_STORY = () => ({
    url: `${urlPrefix}/tradein/official/car-story`,
    title: `Showroom Trade-in - Official - Car Story Step`,
});
const OFFICIAL_TRADEIN_CONDITIONS_FORM = () => ({
    url: `${urlPrefix}/tradein/official/conditions-form`,
    title: `Showroom Trade-in - Official - Conditions Form Step`,
});
const OFFICIAL_TRADEIN_THANKS = () => ({
    url: `${urlPrefix}/tradein/official/thanks`,
    title: `Showroom Trade-in - Official - Thanks Step`,
});
const FINANCING = () => ({
    url: `${urlPrefix}/financing`,
    title: `Showroom Financing Application`,
});
const APPOINTMENT = () => ({
    url: `${urlPrefix}/appointment`,
    title: `Showroom Appointment Booking`,
});
const APPOINTMENT_LOGIN = () => ({
    url: `${urlPrefix}/appointment/login`,
    title: `Showroom Appointment Booking - Login Step`,
});
const APPOINTMENT_FORM_SENT = () => ({
    url: `${urlPrefix}/appointment/form-sent`,
    title: `Showroom Appointment Booking - Form Sent Step`,
});
const CHECKOUT_REVIEW = () => ({
    url: `${urlPrefix}/checkout/review`,
    title: `Showroom Checkout - Review Step`,
});
const CHECKOUT_DEPOSIT = () => ({
    url: `${urlPrefix}/checkout/deposit`,
    title: `Showroom Checkout - Deposit Step`,
});
const CHECKOUT_FINANCING = () => ({
    url: `${urlPrefix}/checkout/financing`,
    title: `Showroom Checkout - Financing Step`,
});
const CHECKOUT_FINANCING_PERSONAL_INFO = () => ({
    url: `${urlPrefix}/checkout/financing/personal`,
    title: `Showroom Checkout - Financing Step - Personal Part`,
});
const CHECKOUT_FINANCING_RESIDENCE_INFO = () => ({
    url: `${urlPrefix}/checkout/financing/residence`,
    title: `Showroom Checkout - Financing Step - Residence Part`,
});
const CHECKOUT_FINANCING_EMPLOYMENT_INFO = () => ({
    url: `${urlPrefix}/checkout/financing/employment`,
    title: `Showroom Checkout - Financing Step - Employment Part`,
});
const CHECKOUT_FINANCING_JOINT_INFO = () => ({
    url: `${urlPrefix}/checkout/financing/joint`,
    title: `Showroom Checkout - Financing Step - Joint Part`,
});
const CHECKOUT_PROTECTIONS = () => ({
    url: `${urlPrefix}/checkout/protections`,
    title: `Showroom Checkout - Protections Step`,
});
const CHECKOUT_PROTECTIONS_INSURANCE = () => ({
    url: `${urlPrefix}/checkout/protections`,
    title: `Showroom Checkout - Protections Step - Insurance Part`,
});
const SIGN_IN = (accountId) => ({
    url: `${urlPrefix}/sign-in`,
    title: `Showroom Sign-In`,
    isLoggedIn: true,
    user_id: accountId && accountId,
});
const FB_CONNECT = () => ({
    url: `${urlPrefix}/facebook-connection`,
    title: `Showroom Facebook Connection`,
});

export default {
    CATALOG,
    VDP_USED,
    VDP_NEW,
    LISTING_NEW,
    LISTING_USED,
    BUILD_AND_QUOTE_YEAR,
    BUILD_AND_QUOTE_TRIM,
    BUILD_AND_QUOTE_PERFORMANCE,
    BUILD_AND_QUOTE_COMFORT,
    BUILD_AND_QUOTE_ACCESSORIES,
    ESTIMATED_TRADEIN_VEHICLE,
    ESTIMATED_TRADEIN_CONDITION,
    OFFICIAL_TRADEIN,
    OFFICIAL_TRADEIN_VEHICLE_FORM,
    OFFICIAL_TRADEIN_CAR_STORY,
    OFFICIAL_TRADEIN_CONDITIONS_FORM,
    OFFICIAL_TRADEIN_THANKS,
    FINANCING,
    APPOINTMENT,
    APPOINTMENT_LOGIN,
    APPOINTMENT_FORM_SENT,
    CHECKOUT_REVIEW,
    CHECKOUT_DEPOSIT,
    CHECKOUT_FINANCING,
    CHECKOUT_FINANCING_PERSONAL_INFO,
    CHECKOUT_FINANCING_RESIDENCE_INFO,
    CHECKOUT_FINANCING_EMPLOYMENT_INFO,
    CHECKOUT_FINANCING_JOINT_INFO,
    CHECKOUT_PROTECTIONS,
    CHECKOUT_PROTECTIONS_INSURANCE,
    SIGN_IN,
    FB_CONNECT,
};
